/**
 * Scriptures for lesson deacon-2 (service as a deacon). Text from churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const deacon2TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-58-26-28',
    reference: 'Doctrine and Covenants 58:26–28',
    text:
      'For behold, it is not meet that I should command in all things; for he that is compelled in all things, the same is a slothful and not a wise servant; wherefore he receiveth no reward. Verily I say, men should be anxiously engaged in a good cause, and do many things of their own free will, and bring to pass much righteousness; For the power is in them, wherein they are agents unto themselves. And inasmuch as men do good they shall in nowise lose their reward.',
    verses: [
      {
        verse: 26,
        text: 'For behold, it is not meet that I should command in all things; for he that is compelled in all things, the same is a slothful and not a wise servant; wherefore he receiveth no reward.',
      },
      {
        verse: 27,
        text: 'Verily I say, men should be anxiously engaged in a good cause, and do many things of their own free will, and bring to pass much righteousness;',
      },
      {
        verse: 28,
        text: 'For the power is in them, wherein they are agents unto themselves. And inasmuch as men do good they shall in nowise lose their reward.',
      },
    ],
    context: 'Serving willingly and doing good without needing a command for every step.',
  },
  {
    id: 'matthew-20-26-28',
    reference: 'Matthew 20:26–28',
    text:
      'But it shall not be so among you: but whosoever will be great among you, let him be your minister; And whosoever will be chief among you, let him be your servant: Even as the Son of man came not to be ministered unto, but to minister, and to give his life a ransom for many.',
    verses: [
      {
        verse: 26,
        text: 'But it shall not be so among you: but whosoever will be great among you, let him be your minister;',
      },
      {
        verse: 27,
        text: 'And whosoever will be chief among you, let him be your servant:',
      },
      {
        verse: 28,
        text: 'Even as the Son of man came not to be ministered unto, but to minister, and to give his life a ransom for many.',
      },
    ],
    context: 'Greatness in the kingdom as minister and servant, after the Savior’s pattern.',
  },
  {
    id: 'alma-37-6-7',
    reference: 'Alma 37:6–7',
    text:
      'Now ye may suppose that this is foolishness in me; but behold I say unto you, that by small and simple things are great things brought to pass; and small means in many instances doth confound the wise. And the Lord God doth work by means to bring about his great and eternal purposes; and by very small means the Lord doth confound the wise and bringeth about the salvation of many souls.',
    verses: [
      {
        verse: 6,
        text: 'Now ye may suppose that this is foolishness in me; but behold I say unto you, that by small and simple things are great things brought to pass; and small means in many instances doth confound the wise.',
      },
      {
        verse: 7,
        text: 'And the Lord God doth work by means to bring about his great and eternal purposes; and by very small means the Lord doth confound the wise and bringeth about the salvation of many souls.',
      },
    ],
    context: 'The Lord often accomplishes His work through small and simple means.',
  },
  {
    id: 'dc-84-106',
    reference: 'Doctrine and Covenants 84:106',
    text: 'And if any man among you be strong in the Spirit, let him take with him him that is weak, that he may be edified in all meekness, that he may become strong also.',
    verses: [
      {
        verse: 106,
        text: 'And if any man among you be strong in the Spirit, let him take with him him that is weak, that he may be edified in all meekness, that he may become strong also.',
      },
    ],
    context: 'Building up the weak with meekness in ministry.',
  },
];
